import React, { useContext } from "react";
import { BlogContext } from "../../App";
import BlogCard from "../cards/blogCard";
import { Link } from "react-router-dom";
import ServicePageSkeleton from "../pages/skeletons/servicePage";
import Button from "../common/Button";

const BlogGroup = () => {
  const { blog, blogLoading } = useContext(BlogContext);
  const safeBlog = Array.isArray(blog) ? [...blog] : [];

  return (
    <>
      {safeBlog.length > 0 && (
        <section className="cht-max-w-7xl cht-mx-auto cht-px-4 sm:cht-px-6 lg:cht-px-8 cht-py-12 md:cht-py-16">
          <header className="cht-text-center cht-mb-10 cht-space-y-2">
            <h2 className="!cht-font-heading cht-text-3xl md:cht-text-4xl !cht-font-extrabold cht-text-[#1e293b]">
              Insights & Articles
            </h2>
            <p className="cht-text-slate-500 cht-text-base cht-font-medium">
              Explore our latest engineering thoughts, industry breakdowns, and headlines
            </p>
          </header>

          <div className="cht-grid cht-grid-cols-1 md:cht-grid-cols-2 lg:cht-grid-cols-3 cht-gap-6 sm:cht-gap-8">
            {safeBlog
              .sort(
                (a: any, b: any) =>
                  new Date(b?.date || b?.pub_date || 0).getTime() -
                  new Date(a?.date || a?.pub_date || 0).getTime()
              )
              .slice(0, 3)
              .map((bItem: any) => (
                <BlogCard
                  key={bItem?.id || bItem?.slug}
                  id={bItem?.id}
                  slug={bItem?.slug}
                  title={bItem?.title}
                  description={bItem?.safe_post_content_html}
                  pub_date={bItem?.pub_date}
                  image_url={bItem?.image}
                  category={bItem?.category?.name}
                  total_comments={bItem?.total_comments}
                  total_likes={bItem?.total_likes}
                />
              ))}
          </div>

          {safeBlog.length > 3 && (
            <div className="cht-flex cht-justify-center cht-mt-10">
              <Button
                to="/blog"
                variant="primary"
                size="md"
              >
                View all Articles
              </Button>
            </div>
          )}
        </section>
      )}

      {blogLoading && <ServicePageSkeleton numberOfCols={3} isTitle={true} />}
    </>
  );
};

export default BlogGroup;
